import { render, staticRenderFns } from "./template-details.vue?vue&type=template&id=8dcac5ec&scoped=true&"
import script from "./template-details.vue?vue&type=script&lang=js&"
export * from "./template-details.vue?vue&type=script&lang=js&"
import style0 from "./template-details.vue?vue&type=style&index=0&id=8dcac5ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcac5ec",
  null
  
)

export default component.exports